import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import RankedDonutCard from 'components/DetailWidgets/RankedDonutCard'
import TabTable from '../TabTable'

function TopBranchesCard({ items }) {
  return (
    <div className="w-full h-full rounded-2xl border border-border-lines p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-base font-semibold text-dark-blue">Top Branches By Sales</p>
        <button type="button" className="text-sm font-medium text-primary flex items-center gap-1">View all Branches <UIcons.UilArrowRight size={14} /></button>
      </div>
      <div className="flex flex-col gap-4">
        {
          items.map((item) => (
            <div key={item.key} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-background flex items-center justify-center shrink-0">
                <UIcons.UilClockThree size={18} className="text-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-dark-blue">{item.label}</p>
                <p className="text-xs text-secondary truncate">{item.description}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-semibold text-dark-blue">{item.percent}%</p>
                <p className="text-xs text-secondary">{item.time}</p>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}

const COLUMNS = [
  {
    key: 'prize',
    label: 'Prize',
    render: (row) => (
      <div className="flex items-center gap-2.5">
        <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <UIcons.UilGift size={16} className="text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-dark-blue">{row.prizeName}</p>
          <p className="text-xs text-secondary">{row.prizeValue}</p>
        </div>
      </div>
    )
  },
  { key: 'rank', label: 'Rank' },
  { key: 'value', label: 'Value' },
  { key: 'date', label: 'Date' },
  { key: 'winnerType', label: 'Winner Type' },
  { key: 'drawFrequency', label: 'Draw Frequency' },
  {
    key: 'status',
    label: 'Status',
    render: (row) => <span className="px-2 py-0.5 rounded text-xs font-medium bg-success bg-opacity-10 text-success">{row.status}</span>
  }
]

export default function PrizesTab({ campaign }) {
  const { prizes } = campaign

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {
          prizes.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilGift} label={stat.label} value={stat.value} suffix={stat.suffix} tone={stat.tone} />
          ))
        }
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <RankedDonutCard
          title="Prize Distribution"
          centerLabel={prizes.distribution.centerLabel}
          centerValue={prizes.distribution.centerValue}
          data={prizes.distribution.data}
        />
        <TopBranchesCard items={prizes.topBranches} />
      </div>

      <TabTable
        columns={COLUMNS}
        rows={prizes.rows}
        searchPlaceholder="Search by prize name"
        searchKeys={['prizeName']}
      />
    </div>
  )
}
